export const BEARER_TOKEN_KEY = "bearer_token";

/**
 * The in-flight two-factor challenge, for surfaces where cookies don't
 * round-trip.
 *
 * The four header names must match the constants of the same name in
 * `apps/server/src/features/auth/plugins/two-factor-bearer-challenge/`. The two
 * apps build separately so neither can import the other; `cors.ts` imports the
 * server's copies for its allowlist, but this side has to be kept in sync by
 * hand — the same arrangement as `MOBILE_OAUTH_CALLBACK_URL`. A mismatch shows
 * up as 2FA sign-in failing on the extension and Capacitor only.
 */
/**
 * One key for the whole challenge. The token, its expiry and the `dontRemember`
 * flag are only meaningful together, so storing them as one JSON value makes a
 * half-written challenge — a token with no expiry, say — unrepresentable.
 */
export const TWO_FACTOR_CHALLENGE_KEY = "two_factor_challenge";

export const TWO_FACTOR_CHALLENGE_REQUEST_HEADER = "x-two-factor-token";
export const TWO_FACTOR_CHALLENGE_RESPONSE_HEADER = "set-two-factor-token";
export const DONT_REMEMBER_REQUEST_HEADER = "x-dont-remember-token";
export const DONT_REMEMBER_RESPONSE_HEADER = "set-dont-remember-token";
